<div class="page">
  <div class="header" (click)="[totalPriceService.stateChange(), (totalPriceService._rotate = !totalPriceService._rotate)]">
    <i class="pageup icon-chevron-up" [ngClass]="{ transform: totalPriceService.order.OrderSetting?.IsShowTotalBox }"> </i>
    <div class="totalpr">
      <span> {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Payable" | translate }} </span
      ><span>{{ totalPriceService.order.invoice.PayableTotal | number }}</span>
    </div>
  </div>
  <div class="main" *ngIf="totalPriceService.order.OrderSetting ? totalPriceService.order.OrderSetting.IsShowTotalBox : false">
    <div class="total">
      <div class="boxprice">
        <div class="rentbox" *ngIf="totalPriceService.order.currentSaleMethodNature === totalPriceService.order.SaleMethodNature.Delivery">
          <span class="rent">{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Rent" | translate }} </span>
          <ssg-input
            [group]="totalPriceService.order.formGroup"
            icon="icon-close-o"
            class="rentinput"
            name="ShippingCost"
            textType="currency"
            [withComma]="true"
            hasClear="true"
            isNumberOnly="true"
            [isReadOnly]="totalPriceService.readOnlyRent"
            (clear)="totalPriceService.clearShippingCost()"
            (onEnter)="totalPriceService.applyShippingCost($event)"
            (oninput)="totalPriceService.applyShippingCost($event)"
            inputMode="numeric"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Rent' | translate">
          </ssg-input>
        </div>
        <div class="salecount" *ngIf="!totalPriceService.order.invoice.HasClub && totalPriceService.showDiscount">
          <div class="sale">
            <div class="salebox">
              <div class="toggle">
                <button
                  class="togglebtn"
                  (click)="totalPriceService.applyDiscount(null, true); totalPriceService.order.focus('Discount'); totalPriceService.inputChange()"
                  [ngClass]="{ active: totalPriceService.order.invoice.IsDiscountPercent }">
                  {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Percent" | translate }}
                </button>
                <button
                  class="togglebtn"
                  (click)="totalPriceService.applyDiscount(null, false); totalPriceService.order.focus('Discount'); totalPriceService.inputChange()"
                  [ngClass]="{ active: !totalPriceService.order.invoice.IsDiscountPercent }">
                  {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.UnitOfPrice" | translate }}
                </button>
              </div>
              <ssg-input
                [group]="totalPriceService.order.formGroup"
                icon="icon-close-o"
                class="saleinput"
                name="Discount"
                #DiscountBox
                textType="text"
                [isFloat]="totalPriceService.order?.currentBranch?.HasDecimal || false"
                inputMode="numeric"
                hasClear="true"
                isNumberOnly="true"
                (clear)="totalPriceService.clearDiscount()"
                autocomplete="off"
                (focus)="totalPriceService.onDiscountfocus()"
                (onEnter)="totalPriceService.applyDiscount($event, null)"
                (oninput)="totalPriceService.inputChange(); totalPriceService.applyDiscount($event, null, true)"
                [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Sale' | translate">
              </ssg-input>
              <div
                class="mr-1"
                *ngIf="
                  (totalPriceService.changeByUser && totalPriceService.order.invoice.Total) ||
                  (totalPriceService.order.invoice.DiscountPrice && totalPriceService.order.invoice.Id && !totalPriceService.clearDiscountFlag)
                "></div>
              <div
                *ngIf="totalPriceService.order.invoice.DiscountType === totalPriceService.discountTypeEnum.HappyHour"
                class="has-happy-hour text-danger">
                {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.HourlyDiscount" | translate }}
              </div>
            </div>
          </div>
          <!-- <span class="saleprice"  *ngIf="!totalPriceService.common.isMobileMode">{{totalPriceService.order.invoice.DiscountPrice | number  }}</span> -->
        </div>
        <div class="servicebox" *ngIf="totalPriceService.order.currentSaleMethodNature === totalPriceService.order.SaleMethodNature.Delivery">
          <div class="service" *ngIf="totalPriceService.order.invoice?.Customer?.HasCredit">
            <div class="toggle">
              <button
                class="togglebtn"
                (click)="totalPriceService.applyDebit(null, true)"
                [class.active]="totalPriceService.order.invoice.Debit > 0 || totalPriceService.order.invoice.isDebit">
                {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Debit" | translate }}
              </button>
              <button
                class="togglebtn"
                (click)="totalPriceService.applyDebit(null, false)"
                [class.active]="totalPriceService.order.invoice.Credit > 0 || !totalPriceService.order.invoice.isDebit">
                {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Credit" | translate }}
              </button>
            </div>
            <ssg-input
              [group]="totalPriceService.order.formGroup"
              icon="icon-published_with_changes-o"
              class="serviceinput"
              name="Debit"
              (iconClick)="totalPriceService.debitTransfer()"
              textType="currency"
              [withComma]="true"
              isNumberOnly="true"
              inputMode="numeric"
              (onEnter)="totalPriceService.applyDebit($event, null)"
              (oninput)="totalPriceService.applyDebit($event, null)"
              label="{{
                totalPriceService.order.invoice.Credit > 0 || !totalPriceService.order.invoice.isDebit
                  ? ('ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Creditor' | translate)
                  : ('ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Debtor' | translate)
              }}">
            </ssg-input>
            <!-- <span>{{totalPriceService.order.invoice.TotalService | number  }}</span> -->
          </div>
        </div>
        <div class="total-saleinput" *ngIf="totalPriceService.order?.saleMethodBranch?.ApplyPackingPrice">
          <ssg-input
            [group]="totalPriceService.order.formGroup"
            icon="icon-close-o"
            class="saleinput"
            name="PackingPrice"
            (clear)="totalPriceService.clearPackingPrice()"
            (onEnter)="totalPriceService.applyPackingPrice($event)"
            (input)="totalPriceService.applyPackingPrice($event)"
            textType="currency"
            [withComma]="true"
            inputMode="numeric"
            hasClear="true"
            autocomplete="off"
            [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Packaging' | translate">
          </ssg-input>
        </div>
        <div
          class="pric servises serviceb"
          *ngIf="
            totalPriceService.order.currentSaleMethodNature !== totalPriceService.order.SaleMethodNature.Delivery &&
            totalPriceService.order?.saleMethodBranch?.ApplyService
          ">
          <div class="title">
            <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Service" | translate }}</span>
            <ssg-swichbox
              class="swich"
              (valueChange)="totalPriceService.order.invoice.IgnoreService = !$event; totalPriceService.order.calculate()"
              [check]="
                totalPriceService.order.invoice.Items.length &&
                totalPriceService.order.saleMethodBranch?.ApplyService &&
                !totalPriceService.order.validFreeService
              "></ssg-swichbox>
          </div>
          <span>{{ totalPriceService.order.invoice.TotalService | number }}</span>
        </div>
        <ssg-checkbox
          *ngIf="totalPriceService.order.saleMethodBranch?.HasSnap && !totalPriceService.order.saleMethodBranch?.InPerson"
          id="ApplySnap"
          name="ApplySnap"
          [group]="totalPriceService.order.formGroup"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.ApplySnap' | translate"
          disabled="false"
          (valueChange)="onApplySnapChanges($event)">
        </ssg-checkbox>
      </div>
      <div class="boxleft">
        <div class="price">
          <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.SumPrice" | translate }} </span
          ><span>{{ totalPriceService.order.invoice.Total | number }}</span>
        </div>
        <div class="price" *ngIf="totalPriceService.order.currentInformation.OrderServices && totalPriceService.order?.saleMethodBranch?.HasDeposit">
          <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.ServiceRate" | translate }} </span
          ><span>{{ totalPriceService.order.depositFormGroup.controls["ServicesAmount"]?.value | number }}</span>
        </div>
        <div class="price">
          <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.SumPercent" | translate }}</span
          ><span>{{ totalPriceService.order.invoice.TotalDiscount | number }}</span>
        </div>
        <div class="price" *ngIf="totalPriceService.order?.saleMethodBranch.ApplyTax">
          <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Taxation" | translate }} </span
          ><span>{{ totalPriceService.order.invoice.TotalTax + totalPriceService.order.invoice.TotalToll | number }}</span>
        </div>
        <div class="price" *ngIf="totalPriceService.order.currentInformation?.OrderServices && totalPriceService.order?.saleMethodBranch?.HasDeposit">
          <span>{{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Remainder" | translate }} </span
          ><span>{{ totalPriceService.order.invoice.PayableTotal - totalPriceService.order.depositFormGroup?.value?.DepositAmount | number }}</span>
        </div>
        <div class="price">
          <span> {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.RoundingAmount" | translate }}</span
          ><span>{{ totalPriceService.order.invoice.RoundingAmount | number }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="clear">
    <div
      #clearButton
      class="clearbutton"
      *ngIf="totalPriceService.invoiceAction.isStartAction === 0 || !totalPriceService?.invoiceAction?.isStartAction">
      <ssg-button
        *ngIf="totalPriceService.order.actionState.save"
        [disabled]="!totalPriceService.order.formGroup?.valid"
        class="login-btn"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Save' | translate"
        buttontype="submit"
        appearance="flat"
        (click)="totalPriceService.invoicesAction(totalPriceService.invoiceCommand.Save)">
      </ssg-button>
      <ssg-button
        *ngIf="this.totalPriceService.order.actionState.temporaryRegister && this.totalPriceService.hasTemporary"
        [disabled]="!totalPriceService.order.formGroup?.valid"
        class="login-btn"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.TemporaryRegister' | translate"
        buttontype="submit"
        appearance="flat"
        (click)="totalPriceService.invoicesAction(totalPriceService.invoiceCommand.TemporaryRegister)">
      </ssg-button>
      <ssg-button
        *ngIf="!totalPriceService.showPrintButton && totalPriceService.order.actionState.preparationPrint"
        [disabled]="!totalPriceService.order.formGroup?.valid"
        class="login-btn"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.PreparationPrint' | translate"
        buttontype="submit"
        appearance="flat"
        (click)="totalPriceService.invoicesAction(totalPriceService.invoiceCommand.PreparationPrint)">
      </ssg-button>
      <ssg-button
        *ngIf="!totalPriceService.showPrintButton && totalPriceService.order.actionState.customerPrint"
        [disabled]="!totalPriceService.order.formGroup?.valid"
        class="login-btn"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.CustomerPrint' | translate"
        buttontype="submit"
        appearance="flat"
        (click)="totalPriceService.invoicesAction(totalPriceService.invoiceCommand.CustomerPrint)">
      </ssg-button>
      <ssg-button
        *ngIf="totalPriceService.showPrintButton && totalPriceService.order.actionState.print"
        [disabled]="!totalPriceService.order.formGroup?.valid"
        class="login-btn canclebtn hidemorebtn"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Print' | translate"
        buttontype="submit"
        appearance="flat"
        (click)="totalPriceService.invoicesAction(totalPriceService.invoiceCommand.Print)">
      </ssg-button>
      <ng-container *ngIf="isContentFitting">
        <ssg-button
          *ngIf="
            (totalPriceService.order.actionState.clearWithoutPrint && !totalPriceService.common.isMobileMode) ||
            (totalPriceService.common.isMobileMode &&
              totalPriceService.order.currentSaleMethodNature === totalPriceService.order.SaleMethodNature.FastFood)
          "
          [disabled]="!totalPriceService.order.formGroup?.valid"
          class="login-btn"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.ClearWithoutPrint' | translate"
          buttontype="submit"
          appearance="flat"
          (click)="totalPriceService.clear(totalPriceService.invoiceCommand.ClearWithoutPrint)">
        </ssg-button>
        <ssg-button
          *ngIf="
            totalPriceService.order.actionState.clear ||
            (totalPriceService.common.isMobileMode &&
              totalPriceService.order.currentSaleMethodNature === totalPriceService.order.SaleMethodNature.FastFood)
          "
          [disabled]="!totalPriceService.order.formGroup?.valid"
          class="login-btn clearing"
          [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Clear' | translate"
          tooltip="f1"
          buttontype="submit"
          appearance="flat"
          (click)="totalPriceService.clear(totalPriceService.invoiceCommand.Clear)">
        </ssg-button>
      </ng-container>
      <ssg-button
        *ngIf="totalPriceService.order.actionState.delivered && totalPriceService.order.saleMethodBranch.HasDeposit"
        [disabled]="!totalPriceService.order.formGroup?.valid"
        class="login-btn clearing"
        [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Delivered' | translate"
        tooltip="f1"
        buttontype="submit"
        appearance="flat"
        (click)="totalPriceService.delivered()">
      </ssg-button>
    </div>
    <ssg-menu
      *ngIf="
        totalPriceService.showChangeClearing ||
        totalPriceService.order.actionState.cancel ||
        (totalPriceService.showPrintButton && totalPriceService.order.actionState.print) ||
        (totalPriceService.hasDefultPayment && totalPriceService.order.actionState.mixClear) ||
        (totalPriceService.order.actionState.clear && totalPriceService.invoiceAction.invoicePrint?.PrintPolicyForTotalPrice?.length) ||
        (totalPriceService.order.currentSaleMethodNature === totalPriceService.order.SaleMethodNature.FastFood &&
          totalPriceService.order.invoice.Items.length > 0) ||
        (totalPriceService.order.currentSaleMethodNature === totalPriceService.order.SaleMethodNature.Delivery &&
          totalPriceService.order.invoice.Items.length > 0) ||
        (totalPriceService.order?.saleMethodBranch.PreprationTimeIsActive && totalPriceService.order.invoice.Items.length > 0)
      "
      icon="icon-more_vert-o"
      class="menubox"
      up="true">
      <ng-container class="menuitem">
        <div class="menu-container">
          <ng-container *ngIf="!totalPriceService.showPrintButton && totalPriceService.order.actionState.customerPrint">
            <div class="menu-item" (click)="totalPriceService.invoicesAction(totalPriceService.invoiceCommand.CustomerTabletPrint)">
              {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.TabletPosCustomerPrint" | translate }}
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              totalPriceService.order.actionState.clear ||
              (totalPriceService.common.isMobileMode &&
                totalPriceService.order.currentSaleMethodNature === totalPriceService.order.SaleMethodNature.FastFood)
            ">
            <div class="menu-item" (click)="totalPriceService.clearAndPrintTabletPos()">
              {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.TabletPosClearAndPrint" | translate }}
            </div>
          </ng-container>
          <ng-container
            *ngIf="totalPriceService.order.actionState.clear && totalPriceService.invoiceAction.invoicePrint?.PrintPolicyForTotalPrice?.length">
            <ng-container *ngFor="let item of totalPriceService.invoiceAction.invoicePrint?.PrintPolicyForTotalPrice">
              <div
                class="menu-item"
                (click)="
                  totalPriceService.invoiceAction.SaveInvoice(
                    totalPriceService.invoiceCommand.CustomerPrint,
                    totalPriceService.order.invoice,
                    null,
                    totalPriceService.order,
                    item.Id
                  )
                ">
                {{ item.PrintTemplate.Title }}
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="totalPriceService.showChangeClearing">
            <div class="menu-item" (click)="changeClearing()">
              {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.ChangeClearing" | translate }}
            </div>
          </ng-container>
          <ng-container *ngIf="totalPriceService.order.actionState.cancel">
            <div
              class="menu-item"
              (click)="
                totalPriceService.invoiceAction.SaveInvoice(
                  totalPriceService.invoiceCommand.Cancel,
                  totalPriceService.order.invoice,
                  null,
                  totalPriceService.order
                )
              ">
              {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Cancel" | translate }}
            </div>
          </ng-container>
          <ng-container *ngIf="totalPriceService.showPrintButton && totalPriceService.order.actionState.print">
            <div
              class="menu-item"
              (click)="
                totalPriceService.invoiceAction.SaveInvoice(
                  totalPriceService.invoiceCommand.Print,
                  totalPriceService.order.invoice,
                  null,
                  totalPriceService.order
                )
              ">
              {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Print" | translate }}
            </div>
          </ng-container>
          <ng-container *ngIf="totalPriceService.order.actionState.clearWithoutPrint">
            <div
              class="menu-item"
              (click)="
                totalPriceService.invoiceAction.SaveInvoice(
                  totalPriceService.invoiceCommand.ClearWithoutPrint,
                  totalPriceService.order.invoice,
                  null,
                  totalPriceService.order
                )
              ">
              {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.ClearWithoutPrint" | translate }}
            </div>
          </ng-container>
          <ng-container *ngIf="totalPriceService.hasDefultPayment">
            <div class="menu-item" (click)="totalPriceService.openMixClearingDialog()">
              {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.CombinedSettlement" | translate }}
            </div>
          </ng-container>
          <ng-container
            *ngIf="
              totalPriceService.order.actionState.clear ||
              totalPriceService.order.actionState.delivered ||
              (totalPriceService.order.actionState.preparationPrint &&
                totalPriceService.order.currentSaleMethodNature != totalPriceService.order.SaleMethodNature.Restaurant)
            ">
            <div class="menu-item" (click)="totalPriceService.changePrintTemplate()">
              {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.ChangeCustomerPrintTemplate" | translate }}
            </div>
          </ng-container>
          <ng-container *ngIf="totalPriceService.order?.saleMethodBranch.PreprationTimeIsActive">
            <div class="menu-item" (click)="totalPriceService.setDeliveryTime()">
              {{ "ClientApp.FrontOffice.Order.OrderPage.Invoice.PreparationDeliveryTime.DeliveryTime" | translate }}
            </div>
          </ng-container>
          <ng-container *ngIf="!isContentFitting">
            <ssg-button
              *ngIf="totalPriceService.order.actionState.clear"
              [disabled]="!totalPriceService.order.formGroup?.valid"
              class="login-btn clearing"
              [label]="'ClientApp.FrontOffice.Order.OrderPage.Invoice.TotalPrice.Clear' | translate"
              tooltip="f1"
              buttontype="submit"
              appearance="flat"
              (click)="totalPriceService.clear(totalPriceService.invoiceCommand.Clear)">
            </ssg-button>
          </ng-container>
        </div>
      </ng-container>
    </ssg-menu>
  </div>
</div>
